import Card from '@packages/ui/card/card.tsx';
import CardHeader from '@packages/ui/card/card-header.tsx';
import CardContent from 'ui/src/card/card-content';
import FormLayout from 'ui/src/form/form-layout';
import { useTranslate } from '@tolgee/react';
import FormItem from 'ui/src/form/form-item';
import TextInput from 'ui/src/form/input/text-input';
import { CompanyCategory } from '@client/graphql/types/graphql.ts';
import { useAuth } from '@client/module/auth/auth-context.ts';
import { Controller, useFormContext } from 'react-hook-form';
import { CompanyForm } from '@client/page/management/company-settings/company-settings.tsx';

export default function CompanyBasicSettings() {
  const { t } = useTranslate();
  const { auth } = useAuth();

  const {
    control,
    formState: { errors },
  } = useFormContext<CompanyForm>();

  return (
    <Card>
      <CardHeader title={'General'} />

      <CardContent>
        <FormLayout>
          <FormItem title={t('common.company-name')}>
            <Controller
              control={control}
              name="name"
              rules={{
                required: t('company.validation.name-not-empty', 'Company name is require'),
                minLength: {
                  value: 3,
                  message: t('company.validation.name-too-short', 'Company name must be at least 2 characters long'),
                },
                maxLength: {
                  value: 50,
                  message: t('company.validation.name-too-long', 'Company name cannot exceed 50 characters'),
                },
              }}
              render={({ field: { onChange, value } }) => (
                <TextInput
                  type="text"
                  label="id"
                  value={value}
                  name="name"
                  error={errors.name?.message}
                  placeholder={t('common.company-name-placeholder')}
                  onChange={onChange}
                />
              )}
            />
          </FormItem>

          {auth?.role.includes('ADMIN') && (
            <FormItem title={t('company.category', 'Company type')} className="max-w-xl">
              <Controller
                control={control}
                name="category"
                render={({ field: { onChange, value } }) => (
                  <div className="grid-cols-2 grid gap-4">
                    {Object.values(CompanyCategory).map((category) => (
                      <div key={category} className="sm:col-span-1 col-span-2">
                        <label className="mr-4"></label>
                        <input
                          className="orm-checkbox text-indigo-600 rounded"
                          type="checkbox"
                          value={category}
                          checked={value.includes(category)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              onChange([...value, category]);
                            } else {
                              onChange(value.filter((c) => c !== category));
                            }
                          }}
                        />{' '}
                        <span className="text-sm">{category}</span>
                      </div>
                    ))}
                  </div>
                )}
              />
            </FormItem>
          )}
        </FormLayout>
      </CardContent>
    </Card>
  );
}
